import * as Sentry from "@sentry/react";

export function initSentry(): void {
  const dsn = import.meta.env.MENTOR_PUBLIC_SENTRY_DSN;
  if (!dsn) {
    console.warn("[Sentry] DSN not configured — error tracking disabled.");
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}

export { Sentry };
